import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";
import {AlertReducer, AuthReducer, UIReducer} from "@leap4/frontend";

const rootReducer = combineReducers({
  auth: AuthReducer,
  ui: UIReducer,
  alert: AlertReducer,
});
const composeEnhancers =
  (window && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
